import { render, staticRenderFns } from "./UserApplications.vue?vue&type=template&id=f4c4dfa0&scoped=true"
import script from "./UserApplications.vue?vue&type=script&lang=js"
export * from "./UserApplications.vue?vue&type=script&lang=js"
import style0 from "./UserApplications.vue?vue&type=style&index=0&id=f4c4dfa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c4dfa0",
  null
  
)

export default component.exports